<template>
  <div class="paging-navigation">
    <vs-dropdown
      class="paging-navigation-button"
      :vs-trigger-click="true"
      color="#039BE5"
    >
      <span class="display-page-label">
        {{ startItemNumber }}-{{ endItemNumber }} / {{ totalItemNumber }}行
      </span>

      <vs-dropdown-menu>
        <vs-dropdown-item
          v-for="(option, index) in displayNumberOptions"
          @click="onSelectDisplayNumber(option)"
          :key="index"
        >
          {{ option }}
        </vs-dropdown-item>
      </vs-dropdown-menu>
    </vs-dropdown>

    <div class="chevron-area">
      <feather-icon
        class="chevron-icon"
        :class="{ disabled: !isPreviousActive }"
        icon="ChevronLeftIcon"
        @click="previousClick()"
      ></feather-icon>
      <feather-icon
        class="chevron-icon"
        :class="{ disabled: !isNextActive }"
        icon="ChevronRightIcon"
        @click="nextClick()"
      ></feather-icon>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    startItemNumber: {
      type: Number,
    },
    endItemNumber: {
      type: Number,
    },
    totalItemNumber: {
      type: Number,
    },
    isPreviousActive: {
      type: Boolean,
    },
    isNextActive: {
      type: Boolean,
    },
    onPreviousClick: {
      type: Function,
    },
    onNextClick: {
      type: Function,
    },
    displayNumberOptions: {
      type: Array,
      default: () => [10, 20, 30],
    },
    onSelectDisplayNumber: {
      type: Function,
      required: true,
    },
  },
  methods: {
    previousClick() {
      if (this.isPreviousActive) {
        this.onPreviousClick();
      }
    },
    nextClick() {
      if (this.isNextActive) {
        this.onNextClick();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.paging-navigation {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 150px;

  .paging-navigation-button {
    cursor: pointer;
  }
  .chevron-area {
    display: flex;
    cursor: pointer;
    width: 55px;
    justify-content: space-between;
    .chevron-icon {
      &.disabled {
        cursor: not-allowed;
        color: rgb(183, 183, 183);
      }
    }
  }
}
</style>
